<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">companies</h1>
        </div>
        <div class="profile">

            <ul class="nav nav-tabs justify-content-start" id="myTab" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'active' }"
                        role="tab"
                        @click="sortStatus = 'active'"
                    >
                        Active Companies
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'inactive' }"
                        role="tab"
                        @click="sortStatus = 'inactive'"
                    >
                        Inactive Companies
                    </a>
                </li>
                <li style="margin-left: auto;">
                    <a href="/admin/company/create" class="btn btn_primary-outline">+ Add Company</a>
                </li>
            </ul>

            <div class="tab-content p-0" id="myTabContent">
                <div class="tab-pane fade show active" v-if="sortedCompanies.length > 0" role="tabpanel">
                    <form action="">
                        <div class="companies">
                            <div class="companies__table">
                                <ul class="companies__list">
                                    <draggable v-model="sortedCompanies" @end="onDragEnd">
                                        <li
                                            class="companies__line"
                                            v-for="company in sortedCompanies"
                                            :key="company.id"
                                        >
                                            <div class="companies__move">
                                                <button type="button" class="move">Move Item</button>
                                            </div>
                                            <div class="companies__photo">
                                                <a href="javascript:void(0)" class="photo">
                                                    <img :src="getNameOfAvatar(company.image)" alt="Company Photo" width="200">
                                                </a>
                                            </div>
                                            <div class="companies__name">
                                                <p class="name"> {{company.name}}</p>
                                            </div>
                                            <div class="companies__edit">
                                                <a :href="`/admin/company/${company.id}/edit`" class="edit">
                                                    <svg width="16" height="16" class="icon">
                                                        <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                                    </svg>
                                                </a>
                                            </div>
                                            <div class="companies__status">
                                                <button
                                                    type="button"
                                                    class="status"
                                                    :class="company.isActive ? 'status_make-inactive' : 'status_make-active'"
                                                    @click="changeStatus(company.id)"
                                                >
                                                    Make {{ company.isActive ? 'Inactive': 'Active' }}
                                                </button>
                                            </div>
                                        </li>
                                    </draggable>

                                </ul>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="tab-pane" id="second" v-else>
                    <div class="categories__empty">
                        <svg width="45" height="45">
                            <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                        </svg>
                        <p>There are no companies</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import {mapActions, mapState} from "pinia";
import {useAdminStore} from "../../stores/AdminStore";
import AdminService from "../../services/AdminService";
import draggable from "vuedraggable";

export default defineComponent({
    name: "ListOfCompanies",
    components: {draggable},
    data() {
        return {
            sortStatus: 'active',
            isCollapsed: {}
        }
    },
    computed: {
        ...mapState(useAdminStore, {
            listOfCompanies: 'companies'
        }),
        sortedCompanies: {
            get() {
                return this.sortStatus === 'active'
                    ? this.listOfCompanies.active
                    : this.listOfCompanies.inactive;
            },
            set(newValue) {
                if (this.sortStatus === 'active') {
                    this.listOfCompanies.active = newValue;
                } else {
                    this.listOfCompanies.inactive = newValue;
                }
            }
        }
    },
    methods: {
        onDragEnd() {
            const newOrderCompanies = this.sortedCompanies.map((item) => item.id);
            this.sendPositionToBackend(newOrderCompanies);
        },

        async sendPositionToBackend(newOrderCompanies) {
            this.$showLoadingMessage()
            try {
                await AdminService.updateCompaniesOrder(newOrderCompanies)
                this.$showSuccessMessage('The order was updated')
            } catch (e) {
                this.$showErrorMessage('The order was not updated')
            }
        },

        ...mapActions(useAdminStore, {
            fetchListOfCompanies: 'fetchListOfCompanies'
        }),
        getNameOfAvatar(photo) {
            return photo ? `/uploads${photo.file_path}` : "/img/svg/avatar.svg";
        },
        async changeStatus(id) {
            try {
                await AdminService.updateCompanyStatus(id)
                await this.fetchListOfCompanies()
            } catch {
                console.error()
            }
        }
    },
    mounted() {
        this.fetchListOfCompanies()
    }
})

</script>



<style scoped>

</style>
